import { z } from 'zod';
import { IconSchema } from '../setting/icon-setting';
import { ShadowSettingKeySchema } from '../setting/shadow-setting';
import { TransparencySettingSchema } from '../setting/transparency-setting';
import { TipTapContentSchema } from '../tiptap-content.schema';
import { BasicAnimationSetSchema } from './animations';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';

export const HotspotFillTypeSchema = z.enum(['ICON', 'IMAGE', 'TEXT']);
export type HotspotFillType = z.infer<typeof HotspotFillTypeSchema>;

export const HotspotExpandDirectionSchema = z.enum(['AUTO', 'LEFT_DOWN', 'LEFT_UP', 'RIGHT_DOWN', 'RIGHT_UP']);
export type HotspotExpandDirection = z.infer<typeof HotspotExpandDirectionSchema>;

export const HotspotIconSchema = IconSchema;
export type HotspotIcon = z.infer<typeof HotspotIconSchema>;

export const HotspotImageSchema = z.object({
  name: z.string(),
  url: z.string(),
});
export type HotspotImage = z.infer<typeof HotspotImageSchema>;

export const HotspotPinComponentPinThemeSettingsSchema = z.object({
  backgroundColor: z.string().optional(),
  innerColor: z.string().optional(),
  contentBackgroundColor: z.string().optional(),
  contentTextColor: z.string().optional(),
  contentBorderColor: z.string().optional(),
  borderSize: z.number().optional(),
  borderColor: z.string().optional(),
  borderRadius: z.number().optional(),
  shadow: ShadowSettingKeySchema,
  transparency: TransparencySettingSchema,
});
export type HotspotPinComponentPinThemeSettings = z.infer<typeof HotspotPinComponentPinThemeSettingsSchema>;

const HotspotSettingsSchema = BasePinComponentSettingsSchema.extend(
  HotspotPinComponentPinThemeSettingsSchema.extend(
    z.object({
      body: TipTapContentSchema,
      fillType: HotspotFillTypeSchema,
      iconFill: HotspotIconSchema,
      imageFill: HotspotImageSchema,
      linkedPinComponent: z.string().nullish(),
      showBody: z.boolean(),
      expandDirection: HotspotExpandDirectionSchema,
      textFill: z.string(),
      title: TipTapContentSchema,
      animations: BasicAnimationSetSchema.optional(),
    }).shape
  ).shape
);
export type HotspotSettings = z.infer<typeof HotspotSettingsSchema>;

export const HotspotPinComponentTypeSchema = z.literal('HOTSPOT');

export const HotspotPinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: HotspotPinComponentTypeSchema,
    settings: HotspotSettingsSchema,
  }).shape
);
